import '../../Lightbox/Styles/_explanation.scss'

window.am = window.am || {};

window.am.explanation = new function () {
    const that = this;
    const tabletWidth = 768;
    const desktopWidth = 1024;

    const KeyCodes = {
        ENTER: 13,
        ESC: 27,
        SPACE: 32
    };

    function setOverlayPosition(linkElement, overlayElement) {

        const bodyRect = document.body.getBoundingClientRect(),
            elemRect = linkElement.getBoundingClientRect(),
            offsetTop = elemRect.top - bodyRect.top;

        overlayElement.style.top = `${offsetTop + elemRect.height - 1}px`;

        if (window.innerWidth < tabletWidth) {
            overlayElement.style.left = 0;
        }
        else {
            const overlayElemRect = overlayElement.getBoundingClientRect();
            let linkOffsetLeft = elemRect.left - bodyRect.left;

            const totalWidthPosition = linkOffsetLeft + overlayElemRect.width;
            let paddingRightBorder = 32;

            if (window.innerWidth < desktopWidth) {
                paddingRightBorder = 16;
            }

            if (totalWidthPosition + paddingRightBorder >= bodyRect.width) {
                const overflowValue = totalWidthPosition - bodyRect.width;
                linkOffsetLeft -= overflowValue;

                // adding some padding
                linkOffsetLeft -= paddingRightBorder;
            }

            overlayElement.style.left = `${linkOffsetLeft}px`;
        }

        const y = elemRect.top + window.scrollY;

        window.scrollTo({
            top: y,
            behavior: 'smooth'
        });
    }

    /**
     * Open explanation function
     * @param {any} e
     * @param {any} overlayElement
     * @returns void
     */
    function openExplanation(e, overlayElement) {

        e.target.blur();
        /* we need to set all this otherwise the newly opened explaination would be closed again by the global close listener */
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const closeButton = overlayElement.querySelector(".close-button");

        closeButton.setAttribute("tabindex", "0");

        /* Show the element to get the correct with for position calculation */
        overlayElement.classList.add('show');

        const element = e.target;

        setOverlayPosition(element, overlayElement);

        if (window.innerWidth >= desktopWidth) {
            closeButton.focus();
        }
    };

    function initResize() {

        window.addEventListener(
            'resize',
            function () {

                const overlayElement = document.querySelector('.explanation-overlay-container.show');

                if (!overlayElement) {
                    return;
                }

                const id = overlayElement.getAttribute('data-id');
                const linkElement = document.querySelector(`[data-lightbox-id="${id}"]`);

                setOverlayPosition(linkElement, overlayElement);
            }
        );
    }

    function initExplanations(aTags) {

        aTags.forEach(function (aTag) {
            let boxId = aTag.getAttribute('data-lightbox-id');

            if (!boxId) {
                return;
            }

            let overlayElement = document.querySelector('.explanation-overlay-container[data-id="' + boxId + '"]');

            if (!overlayElement) {
                return;
            }

            const closeButton = overlayElement.querySelector(".close-button");

            /* Close button event setup */
            closeButton.addEventListener("click", function (e) {
                that.closeExplanation(e, this, overlayElement, aTag);
            });

            closeButton.addEventListener("touch", function (e) {
                closeButton.click();
            });

            closeButton.addEventListener("keydown", function (e) {
                /* Enter, ESC, Space */
                if (e.keyCode == KeyCodes.ENTER || e.keyCode == KeyCodes.ESC || e.keyCode == KeyCodes.SPACE) {
                    /* Only prevent scroll page if space if pressed - on keyup box will be closed */
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                }
            });
            
            closeButton.addEventListener("keyup", function (e) {
                /* Enter, ESC, Space */
                if (e.keyCode == KeyCodes.ENTER || e.keyCode == KeyCodes.ESC || e.keyCode == KeyCodes.SPACE) {
                    closeButton.click();
                }
            });

            /* Link event setup */
            aTag.addEventListener("click", function (e) {
                /* Ensure previous openend */
                closeExplanationInternal(null, false);
                openExplanation(e, overlayElement);
            });

            aTag.addEventListener("keydown", function (e) {
                /* Prevent open modal while enter is pressed (should only be opened if released) */
                if (e.keyCode == KeyCodes.ENTER) {
                    e.preventDefault();
                }
            }, false);

            aTag.addEventListener("keyup", function (e) {
                /* Open modal if enter or space is released */
                if (e.keyCode == KeyCodes.ENTER || e.keyCode == KeyCodes.SPACE) {
                    aTag.click();
                }
            }, false);
        });
    }

    function initGlobalCloseExplanationListener() {
        document.addEventListener('click', function (e) {

            const currentElement = e.target;

            closeExplanationInternal(currentElement, currentElement);
        });
    }

    function closeExplanationInternal(currentElement, setFocusOnClickedLink) {
        const overlayElement = document.querySelector('.explanation-overlay-container.show');

        if (!overlayElement) {
            return;
        }

        if (currentElement && overlayElement.contains(currentElement)) {
            return;
        }

        const closeButton = overlayElement.querySelector('.close-button');

        if (overlayElement.classList.contains('show')) {
            overlayElement.classList.remove('show');
        }

        closeButton.setAttribute("tabindex", -1);

        if (window.innerWidth >= tabletWidth && setFocusOnClickedLink) {

            const id = overlayElement.getAttribute('data-id');
            const element = document.querySelector(`[data-lightbox-id="${id}"]`);
            element.focus();
        }
    }

    that.init = function () {
        that.moveExplanationContainersToBody();
        const aTags = document.querySelectorAll('a[target="_explanation"]');

        if (aTags == null) {
            return;
        }

        initResize();
        initExplanations(aTags);
        initGlobalCloseExplanationListener();
    };

    that.closeExplanation = function (e, closeButton, explanationContainer, opener) {

        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        if (explanationContainer.classList.contains('show')) {
            explanationContainer.classList.remove('show');
        }

        closeButton.setAttribute("tabindex", -1);

        if (window.innerWidth >= tabletWidth && opener) {
            opener.focus();
        }
    };

    that.moveExplanationContainersToBody = function () {
        const overlayElements = document.querySelectorAll(".explanation-overlay-container");

        if (!overlayElements) {
            return;
        }

        const body = document.querySelector('body');
        const explanationIds = [];

        overlayElements.forEach(function (overlayElement) {
            const dataId = overlayElement.getAttribute("data-id");

            if (explanationIds.includes(dataId)) {
                // It can be possible that we have more then one explanation container
                // with the same id. Based on cacheable renderings vs not cacheable renderings.
                // Therefore we need to remove the doubled explanation content container
                overlayElement.remove();
                return;
            }

            explanationIds.push(dataId);
            body.append(overlayElement);
        });
    };
};

window.addEventListener('load', window.am.explanation.init);